/* ============================================================
   Puddi PDP hero — batch 6A
   Size picker updates the hidden variant id, live prices, ATC
   label, and sticky ATC. Qty stepper updates the hidden quantity
   input and pluralizes the size label. Sticky ATC delegates to
   the main ATC so Shopify's normal form submission runs.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('.puddi-pdp');
  if (!root) return;

  var form = root.querySelector('.puddi-pdp-form');
  if (!form) return;

  var variantInput = form.querySelector('[data-zone="variant-input"]');
  var qtyInput     = form.querySelector('[data-zone="qty-input"]');
  var mainAtc      = form.querySelector('[data-zone="atc-btn"]');
  var atcPriceEl   = form.querySelector('[data-zone="atc-price"]');
  var priceEl      = form.querySelector('[data-zone="price-current"]');
  var qtyLabelEl   = form.querySelector('[data-zone="qty-label"]');
  var qtyMinusBtn  = form.querySelector('[data-zone="qty-minus"]');
  var qtyPlusBtn   = form.querySelector('[data-zone="qty-plus"]');
  var sizeButtons  = form.querySelectorAll('[data-zone="sizes"] .sz');

  var stickyNameEl  = root.querySelector('[data-zone="sticky-name"]');
  var stickyPriceEl = root.querySelector('[data-zone="sticky-price"]');
  var stickyBtn     = root.querySelector('[data-zone="sticky-btn"]');
  var stickyBase    = root.getAttribute('data-sticky-base') || '';

  // Current selected size label (short form: "six-pack" / "dozen" / "case")
  function getActiveSizeLabel() {
    var active = form.querySelector('[data-zone="sizes"] .sz.on');
    return active ? active.getAttribute('data-size-label') : 'pack';
  }

  function getActiveSizeSuffix() {
    var active = form.querySelector('[data-zone="sizes"] .sz.on');
    return active ? active.getAttribute('data-size-suffix') : '';
  }

  function updateQtyLabel(n) {
    if (!qtyLabelEl) return;
    var label = getActiveSizeLabel();
    var text = n + ' ' + label + (n > 1 ? 's' : '');
    qtyLabelEl.textContent = text;
  }

  // Size picker
  sizeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      var price     = btn.getAttribute('data-variant-price');
      var suffix    = btn.getAttribute('data-size-suffix');

      sizeButtons.forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');

      if (variantInput) variantInput.value = variantId;
      if (priceEl)      priceEl.textContent    = price;
      if (atcPriceEl)   atcPriceEl.textContent = price;
      if (stickyPriceEl) stickyPriceEl.textContent = price;
      if (stickyNameEl)  stickyNameEl.textContent  = stickyBase + ' · ' + suffix;

      var n = parseInt(qtyInput.value, 10) || 1;
      updateQtyLabel(n);
    });
  });

  // Qty stepper
  if (qtyMinusBtn) {
    qtyMinusBtn.addEventListener('click', function () {
      var n = parseInt(qtyInput.value, 10) || 1;
      n = Math.max(1, n - 1);
      qtyInput.value = n;
      updateQtyLabel(n);
    });
  }
  if (qtyPlusBtn) {
    qtyPlusBtn.addEventListener('click', function () {
      var n = parseInt(qtyInput.value, 10) || 1;
      n = Math.min(9, n + 1);
      qtyInput.value = n;
      updateQtyLabel(n);
    });
  }

  // Sticky ATC delegates to the main ATC so form submission runs normally
  if (stickyBtn && mainAtc) {
    stickyBtn.addEventListener('click', function () {
      mainAtc.click();
    });
  }
})();
